import React from 'react'
import Skeleton from '../Skeleton'

const AnalyticsSkeleton = () => {
    return (
        <div className="p-4 sm:p-6 max-w-7xl mx-auto">
            {/* Header */}
            <div className="mb-6 sm:mb-8">
                <Skeleton className="h-8 w-64 mb-2" />
                <Skeleton className="h-4 w-96 max-w-full" />
            </div>

            {/* Navigation */}
            <div className="flex items-center space-x-2 mb-6 sm:mb-8 pb-2 sm:pb-0">
                <Skeleton className="h-9 w-24 rounded-xl" />
                <Skeleton className="h-9 w-24 rounded-xl" />
                <Skeleton className="h-9 w-24 rounded-xl" />
            </div>

            {/* Key Metrics */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mb-8">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="card p-6">
                        <div className="flex items-center space-x-3">
                            <Skeleton className="h-12 w-12 rounded-xl" />
                            <div className="space-y-1">
                                <Skeleton className="h-4 w-24" />
                                <Skeleton className="h-6 w-16" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Charts Section (Overview Layout) */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Budget vs Spending */}
                <div className="card p-6">
                    <div className="flex items-center space-x-2 mb-6">
                        <Skeleton className="h-5 w-5" />
                        <Skeleton className="h-6 w-48" />
                    </div>
                    <div className="w-full h-[300px] flex items-end space-x-4">
                        {[1, 2, 3, 4, 5, 6].map((i) => (
                            <div key={i} className="flex-1 space-x-1 flex items-end h-full">
                                <Skeleton className={`w-full rounded-t`} style={{ height: `${Math.random() * 60 + 20}%` }} />
                                <Skeleton className={`w-full rounded-t`} style={{ height: `${Math.random() * 80 + 20}%` }} />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Category Distribution */}
                <div className="card p-6">
                    <div className="flex items-center space-x-2 mb-6">
                        <Skeleton className="h-5 w-5" />
                        <Skeleton className="h-6 w-48" />
                    </div>
                    <div className="flex justify-center items-center h-[300px]">
                        <Skeleton className="h-48 w-48 rounded-full" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AnalyticsSkeleton
